import {
  LOGIN_SUCCESS,
  LOGOUT,
  STORE_REDIRECT_URL,
  CLEAR_REDIRECT_URL,
} from "./actionTypes";

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
});

export const logout = () => ({
  type: LOGOUT,
});

export const storeRedirectUrl = (url) => ({
  type: STORE_REDIRECT_URL,
  payload: url,
});

export const clearRedirectUrl = () => ({
  type: CLEAR_REDIRECT_URL,
});
